import type { AgentPanelTabState } from '@shiftagent/shared';

export interface AgentPanelTabProps {
  tabs: AgentPanelTabState[];
  activeTabId: string | null;
  onSelect: (tabId: string) => void;
}

export function AgentPanelTab({ tabs, activeTabId, onSelect }: AgentPanelTabProps) {
  if (tabs.length === 0) return null;

  return (
    <div
      role="tablist"
      aria-label="Canvas tabs"
      className="flex items-end overflow-x-auto sd-scrollbar-none border-b border-sd-border/20 bg-sd-background px-sd-1"
    >
      {tabs.map((tab) => {
        const isActive = tab.tab_id === activeTabId;
        return (
          <button
            key={tab.tab_id}
            role="tab"
            aria-selected={isActive}
            onClick={() => onSelect(tab.tab_id)}
            className={[
              'relative flex-shrink-0 h-8 px-sd-3 text-sd-xs transition-colors duration-150',
              'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-inset focus-visible:ring-sd-primary/50',
              isActive
                ? 'text-sd-text font-semibold'
                : 'text-sd-text-secondary font-medium hover:text-sd-text hover:bg-sd-surface-elevated/50',
            ].join(' ')}
          >
            <span className="max-w-[80px] truncate block">{tab.title}</span>
            {/* Active underline — amber accent matches agent identity thread */}
            {isActive && (
              <span className="absolute bottom-0 left-0 right-0 h-[2px] bg-sd-warning rounded-t-full" />
            )}
          </button>
        );
      })}
    </div>
  );
}
